import { render, staticRenderFns } from "./SizeChartEdit.vue?vue&type=template&id=65a64911&scoped=true"
import script from "./SizeChartEdit.vue?vue&type=script&lang=js"
export * from "./SizeChartEdit.vue?vue&type=script&lang=js"
import style0 from "./SizeChartEdit.vue?vue&type=style&index=0&id=65a64911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a64911",
  null
  
)

export default component.exports